import { render, staticRenderFns } from "./AdText.vue?vue&type=template&id=47eca40c&"
import script from "./AdText.vue?vue&type=script&lang=js&"
export * from "./AdText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports